import { configureStore, MiddlewareArray } from '@reduxjs/toolkit'
import { createRouterMiddleware } from '@lagunovsky/redux-react-router'
import { createBrowserHistory } from 'history'
import createSagaMiddleware from 'redux-saga'

import createRootReducer from './reducers'
import saga from './sagas'

export const history = createBrowserHistory()
const routerMiddleware = createRouterMiddleware(history)

const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
    reducer: createRootReducer(history),
    middleware: new MiddlewareArray().concat(sagaMiddleware).concat(routerMiddleware),
})

sagaMiddleware.run(saga)

export default store
